import { SelectModelModel } from '../../../select/select-model';

export const HEADING_LEVEL_MODEL: SelectModelModel = [
  { value: 'h1', item: 'H1' },
  { value: 'h2', item: 'H2' },
  { value: 'h3', item: 'H3' },
] as const;

export type HeadingLevel = (typeof HEADING_LEVEL_MODEL)[number]['value'];
